import {
  isArrayNotEmpty,
  findName,
  splitName,
  pluralizeCost,
  Id,
} from './utils';

const sourceName = (dictionary: Array<any>, id: Id): string => {
  if (!isArrayNotEmpty(dictionary) && !id) return '';
  const result = findName(dictionary, id);
  return result ? splitName(result.name) : '';
};

const financingCost = (value: Id): string => {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  return pluralizeCost(value);
};

const financigService = {
  sourceName,
  financingCost,
};

export default financigService;



// WEBPACK FOOTER //
// ./src/services/financigservice/financingService.ts